/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Next_Result_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Next result" |
*
* @param {Find_Replace_Next_Result_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_next_result_aria_label = /** @type {((inputs?: Find_Replace_Next_Result_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Next_Result_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Resultat suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Nächstes Ergebnis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultato successivo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Следующий результат")
	if (locale === "es") return /** @type {LocalizedString} */ ("Siguiente resultado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下一个结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次の結果")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगला परिणाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Próximo resultado")
	return /** @type {LocalizedString} */ ("Next result")
});